const vitaminOptions = [
  { value: '5-htp', label: '5-HTP' },
  { value: 'apple-cider-vinegar', label: 'Apple Cider Vinegar' },
  { value: 'ashwagandha-extract', label: 'Ashwagandha Extract' },
  { value: 'beetroot-powder', label: 'Beetroot' },
  { value: 'beta-glucan', label: 'Beta Glucan' },
  { value: 'bpl1-ht', label: 'BPL1® HT' },
  { value: 'careflow-mango-powder', label: 'Careflow™ Mango Powder' },
  { value: 'coq10', label: 'CoQ10' },
  { value: 'cordyceps', label: 'Cordyceps' },
  { value: 'folic-acid', label: 'Folic Acid' },
  { value: 'ginger-extract', label: 'Ginger Extract' },
  { value: 'ginseng', label: 'Ginseng' },
  { value: 'hydrocurc-pepperine', label: 'HydroCurc™ & Black Pepper Extract' },
  { value: 'inositol', label: 'Inositol' },
  { value: 'inositol-2', label: 'Inositol (second layer)', disabled: true },
  { value: 'iodine', label: 'Iodine' },
  { value: 'iron', label: 'Iron' },
  { value: 'k2-vital-delta', label: 'K2 Vital Delta™' },
  { value: 'lactospore-probiotic', label: 'LactoSpore® Probiotic' },
  { value: 'lutemax', label: 'Lutemax' },
  { value: 'lycopene', label: 'Lycopene' },
  { value: 'maca-powder', label: 'Maca Powder' },
  { value: 'milk-thistle-extract', label: 'Milk Thistle Extract' },
  { value: 'nourished-greens', label: 'Nourished Greens' },
  { value: 'resveratrol', label: 'Resveratrol' },
  { value: 'scutellup', label: 'Scutell\'Up' },
  { value: 'selenium', label: 'Selenium' },
  { value: 'silica', label: 'Silica' },
  { value: 'tart-cherry', label: 'Tart Cherry' },
  { value: 'vegan-vitamin-d3', label: 'Vegan Vitamin D3' },
  { value: 'vegan-vitamin-d3-2', label: 'Vegan Vitamin D3 (second layer)', disabled: true },
  { value: 'vitamin-a', label: 'Vitamin A' },
  { value: 'b12', label: 'Vitamin B12' },
  { value: 'vitamin-c', label: 'Vitamin C' },
  { value: 'vitamin-e', label: 'Vitamin E' },
  { value: 'white-kidney-extract', label: 'White Kidney Bean Extract' },
  { value: 'zinc', label: 'Zinc' },
];

export default vitaminOptions;